import { render } from "./ChartPie.vue?vue&type=template&id=0960eb97"
import script from "./ChartPie.vue?vue&type=script&lang=js"
export * from "./ChartPie.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/Advanced/ChartPie.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0960eb97"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0960eb97', __exports__)) {
    api.reload('0960eb97', __exports__)
  }
  
  module.hot.accept("./ChartPie.vue?vue&type=template&id=0960eb97", () => {
    api.rerender('0960eb97', render)
  })

}


export default __exports__